import { memo } from 'react';
import { Link } from 'react-router-dom';


import ChevronLeftIcon from 'Icons/ChevronLeftIcon';
import ChevronRightIcon from 'Icons/ChevronRightIcon';
import ClientIcon from 'Icons/ClientIcon';
import EnterpriseIcon from 'Icons/EnterpriseIcon';
import LicenceIcon from 'Icons/LicenceIcon';
import MaterielIcon from 'Icons/MaterielIcon';
import ParameterIcon from 'Icons/ParameterIcon';
import ProductionIcon from 'Icons/ProductionIcon';
import ReportIcon from 'Icons/ReportIcon';
import RevertoLogoIcon from 'Icons/RevertoLogoIcon';
import SupportIcon from 'Icons/SupportIcon';
import TableauBordIcon from 'Icons/TableauBordIcon';
import TokenIcon from 'Icons/TokenIcon';
import RNavItem from './RNavItem';

import { usePermissions } from 'features/auth/hooks/usePermissions';
import { siteVersion } from '../../configs/url';
import './style.css';

const Navbar = ({ open = false, setOpen, isMobile = false }) => {
    const { checkLevel, checkPermission, isRevertoEmployee } = usePermissions();
    const logo_id = open ? "logo-open" : "logo-close";
    const support_button = open ? "support-button" : "support-button-close";

    return (
        <div id={"main-menu"}>
            {
                isMobile ? null :
                    open ?
                        <ChevronLeftIcon className='retract-icon' onClick={() => setOpen(!open)} />
                    :
                        <ChevronRightIcon className='retract-icon' onClick={() => setOpen(!open)} />
            }
            <Link to={"/"}>
                <RevertoLogoIcon height={"100%"} width={"100%"} className="main-logo" id={logo_id}/>
            </Link>
            {
                isRevertoEmployee() ?
                        <>
                            <Menu open={open} checkLevel={checkLevel} checkPermission={checkPermission} />
                            <div className='version-site-web-container'>
                                {siteVersion}
                            </div>
                        </>
                    :
                        <>
                            <Menu open={open} checkLevel={checkLevel} checkPermission={checkPermission} />
                            <Link className="RNavItemLink" to={"/contact"} >
                                <div className={support_button}>
                                    <SupportIcon color="white" />
                                    <span>Contacter Reverto</span>
                                </div>
                            </Link>
                            <div className="version-site-web-container">
                                {siteVersion}
                            </div>
                        </>
            }
        </div>
    );
}

const Menu = ({ open, checkLevel, checkPermission }) => {
    return (
        <>
            <RNavItem open={open} text="Tableau de bord" link="/dashboard" icon={<TableauBordIcon color="white"/>} />
            {checkPermission("content.read") ? <RNavItem open={open} text="Production" link="/contents" icon={<ProductionIcon color="white"/>} /> : null}
            {checkPermission("enterprises.read") ? <RNavItem open={open} text="Mon entreprise" link="/enterprise/utilisateurs" icon={<EnterpriseIcon color="white"/>} /> : null}
            {checkPermission("licences.read") ? <RNavItem open={open} text="Mes licences" link="/enterprise/licences" icon={<LicenceIcon color="white"/>} /> : null}
            {checkPermission("reports.read_create") ? <RNavItem open={open} text="Mes rapports" link="/enterprise/rapports" icon={<ReportIcon color='white' />} /> : null}
            {checkPermission("casques.read") ? <RNavItem open={open} text="Mon matériel" link="/enterprise/materiels" icon={<MaterielIcon color="white"/>} /> : null}
            {checkPermission("enterprises.read") ? <RNavItem open={open} text="Mes organisations" link="/enterprise/entreprises" icon={<ClientIcon color="white"/>} /> : null}
            {checkLevel(0) ? <RNavItem open={open} text="Tokens" link="/tokens" icon={<TokenIcon color="white"/>} /> : null}
            {checkLevel(0) ? <RNavItem open={open} text="Paramètres" link="/parameters" icon={<ParameterIcon color="white"/>} /> : null}
        </>
    )
}

export default memo(Navbar);


